var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIconColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 11.25C6.75 9.12868 6.75 8.06802 7.40901 7.40901C8.06802 6.75 9.12868 6.75 11.25 6.75L12 6.75C14.1213 6.75 15.182 6.75 15.841 7.40901C16.5 8.06802 16.5 9.12868 16.5 11.25V12C16.5 14.1213 16.5 15.182 15.841 15.841C15.182 16.5 14.1213 16.5 12 16.5H11.25C9.12868 16.5 8.06802 16.5 7.40901 15.841C6.75 15.182 6.75 14.1213 6.75 12L6.75 11.25Z",
    stroke: "#368EC3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7499 6.75C12.7482 4.53218 12.7146 3.38341 12.069 2.59682C11.9444 2.44492 11.8051 2.30563 11.6532 2.18097C10.8234 1.5 9.59061 1.5 7.125 1.5C4.65939 1.5 3.42658 1.5 2.59682 2.18097C2.44492 2.30563 2.30563 2.44492 2.18097 2.59682C1.5 3.42658 1.5 4.65939 1.5 7.125C1.5 9.59061 1.5 10.8234 2.18097 11.6532C2.30563 11.8051 2.44492 11.9444 2.59682 12.069C3.38341 12.7146 4.53218 12.7482 6.75 12.7499",
    stroke: "#368EC3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconColored);
export default __webpack_public_path__ + "static/media/copy-icon-colored.848740e4b4c5da528bf453f259c6b097.svg";
export { ForwardRef as ReactComponent };